export default "__VITE_ASSET__0boIOhHO__"